<template>
  <b-modal
    v-if="tracks != null"
    ref="modal"
    centered
    :visible="tracks.length > 0"
    @hidden="cancelModal"
    modal-class="modal-condensed"
  >
    <template slot="modal-header">
      <!--      <h1>{{ Translations.sections.tracks.edition.categories }}</h1>-->
      <h1>Categories</h1>
      <div>
        <Button
          :empty="true"
          class="close-popup"
          @click.prevent="cancelModal"
        >{{ Translations.buttons.cancel }}</Button>
        <Button :empty="false" :noBorder="true" class="validate" @click.prevent="updateTracks">Done</Button>
      </div>
    </template>
    <template>
      <div class="flex-container">
        <div class="form-container search">
          <input
            v-focus
            type="text"
            maxlength="100"
            placeholder="Search Category"
            v-model="searchData.searchTerm"
          />
        </div>
        <div class="search-result">
          <WaitingBlock v-if="modalState.isLoadingCategories"></WaitingBlock>
          <template v-else-if="searchResult != null && searchResult.dataItem != null && searchResult.dataItem.length > 0 && filteredCategories.length > 0" >
            <div v-for="category in filteredCategories" :key="category.id" style="margin-left: 15px; margin-top: 5px">
               <div @click.prevent="toggleCategory(category)"  >
                  <i :class="['far', selectedCategories[category.id] === undefined ? 'fa-square':'fa-check-square']" ></i>
                  <span class="name">{{category.name}}</span>
               </div>
            </div>
          </template>
          <div v-else class="no-result-container">
            <header>
              <strong>No category matching your search criteria</strong>
            </header>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <div class="selection-container">
        <template v-if="selectedCategoriesData.length>0">
          <header>{{selectedCategoriesData.length}} selected categories :</header>
          <section>
            <div
              v-for="category in selectedCategoriesData.categories"
              :key="category.id"
              :class="['badge', 'category-badge',{'selected' : selectedCategories[category.id] === undefined}]"
            >
              <span class="name">{{category.name}}</span>
              <span class="selector">
                <i class="fas fa-trash" @click.prevent="toggleCategory(category)"></i>
              </span>
            </div>
          </section>
        </template>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Vue from "vue";
import Button from "@/components/common/Button";
import Bootstrap from "bootstrap-vue";
import store from "@/store";
import router from "@/router";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import Portlet from "@/components/common/Portlet.vue";
import { HTTP } from "@/utils/http";
import Apis from "@/apis/index";
import { mapState } from "vuex";
import WaitingBlock from "@/components/common/WaitingBlock";

export default {
  name: "SelectorCategories",
  components: { Portlet, Bootstrap, Button, WaitingBlock },
  computed: {
    Translations: () => Translations,
    trackUids() {
      return this.tracks.map(track => track.uid);
    },
    selectedCategoriesData() {
      return {
        length: Object.keys(this.selectedCategories).length,
        categories: Object.values(this.selectedCategories).sort(function(a, b) {
          return a.displayOrder - b.displayOrder;
        })
      };
    },
    filteredCategories() {
      var str = (this.searchData.searchTerm || "").trim();
      if (str == null || str == "") return this.searchResult.dataItem || [];
      str = this.normalizeSearchTerm(str);
      str = this.normalizeSearchTerm(str);
      return this.searchResult.dataItem.filter(category => {
        return category.name.toLowerCase().includes(str.toLowerCase())
      })
    }
  },
  mounted() {
    this.search();
    // Set search input autofocus
  },
  directives: {
    focus: {
      // When the bound element is inserted into the DOM...
      inserted: function(el) {
        // hack to trigger inside method
        setTimeout(() => {
          el.focus();
        }, 0);
      }
    }
  },
  props: {
    stationUid: { required: true },
    multiselect: { required: false, default: true },
    noModalEdit: null,
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalState: {
        hasSearchProcessed: false,
        isLoadingCategories: false,
        delayedSearch: null
      },
      tracks: [],
      selectedCategories: {},
      searchResult: null,
      searchData: {
        searchTerm: "",
        pageSize: 50,
        page: 1
      },
      reducedCategories: []
    };
  },
  methods: {
    normalizeSearchTerm(str) {
      return (str || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    // ------------------------------------------------------
    /* Start : Common Behaviour */
    // ------------------------------------------------------
    show() {
      this.$refs.modal.show();
    },
    edit(categories) {
      this.selectedCategories = categories && categories.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});

      this.show();
    },
    editForTracks(tracks) {
      var tmpCategories = {};
      this.tracks = tracks;
      if (this.tracks.length === 1) {
        for (var i = 0; i < (this.tracks[0].categories || []).length; i++) {
          tmpCategories[this.tracks[0].categories[i].id] = this.tracks[0].categories[i];
        }
      }

      this.selectedCategories = tmpCategories;
      this.show();
    },
    searchDelay(delay) {
      if (this.delayedSearch != null) clearTimeout(this.delayedSearch);
      this.delayedSearch = setTimeout(this.search, delay || 150);
    },
    search() {
      this.modalState.isLoadingCategories = true;

      try {
        HTTP.get(Apis.parameters.categories)
          .then(this.searchEnd)
          .catch(this.searchError)
          .then(this.searchCompleted);
      } catch (e) {
        console.log(e);
      }
    },
    searchEnd(response) {
      this.searchResult = response.data;
      // console.log('search result :', this.searchResult);
    },
    searchError(response) {
      this.searchResult = response.data;
    },
    searchCompleted(response) {
      this.modalState.isLoadingCategories = false;
      this.modalState.hasSearchProcessed = true;
    },
    cancelModal() {
      this.modalState.hasSearchProcessed = true;
      this.searchData.searchTerm = "";
      this.$emit("onHidden");
      this.$refs["modal"].hide();
    },
    // ------------------------------------------------------
    /* End : Common Behaviour */
    // ------------------------------------------------------
    async updateTracks() {
        this.cancelModal();
        this.$emit("newValueCategories", "categories", this.selectedCategoriesData.categories);
        return;

    },
    toggleCategory(category) {
      // console.log(category);
      category.isSelected = !category.isSelected;

      if (this.selectedCategories[category.id] != null) {
        Vue.delete(this.selectedCategories, category.id);
      } else {
        if (!this.multiselect) {
          this.selectedCategories = {};
        }

        const newCategory = category;
        const { id } = category;
        newCategory.displayOrder = new Date().getTime();

        this.selectedCategories = { ...this.selectedCategories, [category.id]: category };

      }

    },
    toggleReducedCategories(id) {
      // if categoryd id already in toggleList, remove it

      const isReduced =
        this.reducedCategories && this.reducedCategories.find(el => el === id);

      if (isReduced) {
        this.reducedCategories = [...this.reducedCategories].filter(el => el !== id);
        return;
      }

      this.reducedCategories = [...this.reducedCategories, id];
    },
    isCategoryReduced(id) {
      return this.reducedCategories && this.reducedCategories.includes(id);
    }
  }
};
</script>

<style lang="scss" scoped>
.category-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;

  &.--child {
    margin-left: 10px;
    cursor: pointer;
  }
}

.no-result-container header {
  padding: 20px 25px;
}

.name {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 1em;
}

.selector i,
.visible i {
  cursor: pointer;
}

.flex-container {
  display: flex;
  flex-direction: column;
}

.form-container {
  padding: 10px 25px;
  background: white;
}

.form-container.search {
  box-shadow: 0 5px 5px -5px #d2d2d2;
  position: sticky;
  top: 0px;
}

.search-container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.selection-container {
  background: white;
  max-height: 150px;
  overflow-y: auto;
  display: block;
  box-shadow: 0 -5px 5px -5px white;
  width: 100%;
}

.selection-container header {
  position: sticky;
  top: 0px;
  font-weight: 600;
  font-size: 13px;
  text-decoration: underline;
  background: white;
  padding: 10px 0;
}

.selection-container section {
  padding: 0 0;
  display: flex;
  flex-wrap: wrap;
}

.selection-container .badge {
  border-radius: 100px;
  display: inline-flex;
  padding: 5px 10px;
  color: white;
  align-items: center;
  margin: 5px;

  .name {
    flex-shrink: 0;
    width: auto;
  }
}

.far.fa-eye {
  color: white;
}

.far.fa-eye-slash {
  color: #ff2213;
}

.search-result {
  height: 400px;
  overflow: auto;
  max-height: 400px;
  overflow: auto;
}
</style>
